import { formatDistanceToNow } from 'date-fns'
import { useNotificationHistory } from '@/api/hooks/use-notifications'
import { AlertRulesSection } from './notifications-alerts'
import { SlackSection } from './notifications-slack'

export function NotificationsPage(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-2xl space-y-8">
      <h1 className="text-2xl font-semibold text-text-primary">Notifications</h1>
      <SlackSection />
      <AlertRulesSection />
      <NotificationHistorySection />
    </div>
  )
}

function NotificationHistorySection(): React.JSX.Element {
  const { data, isLoading } = useNotificationHistory({ page: 1, per_page: 10 })

  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <h2 className="text-lg font-semibold text-text-primary">Recent Alerts</h2>

      {isLoading ? (
        <p className="mt-4 text-center text-sm text-text-tertiary">Loading alert history...</p>
      ) : !data || data.data.length === 0 ? (
        <p className="mt-4 text-center text-sm text-text-tertiary">No alerts triggered yet.</p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-surface-3 text-left text-text-secondary">
                <th className="pb-2 font-medium">Type</th>
                <th className="pb-2 font-medium">Triggered</th>
                <th className="pb-2 font-medium">Channel</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-surface-3">
              {data.data.map((entry) => (
                <tr key={entry.id}>
                  <td className="py-2.5 text-text-primary">{entry.type}</td>
                  <td className="py-2.5 text-text-secondary">
                    {formatDistanceToNow(new Date(entry.sent_at), { addSuffix: true })}
                  </td>
                  <td className="py-2.5 capitalize text-text-secondary">{entry.channel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
